import { render, staticRenderFns } from "./FKomoditiImportDialog.vue?vue&type=template&id=4e850c75&scoped=true"
import script from "./FKomoditiImportDialog.vue?vue&type=script&lang=js"
export * from "./FKomoditiImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e850c75",
  null
  
)

export default component.exports